// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"xo-z","slideIn":"yo-z"};